function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "b"
}, React.createElement("rect", {
  width: 48,
  height: 48
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, React.createElement("g", {
  transform: "translate(4 4)",
  fill: "none",
  stroke: "#091832",
  strokeWidth: 2
}, React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 9,
  stroke: "none"
}), React.createElement("rect", {
  x: 1,
  y: 1,
  width: 38,
  height: 38,
  rx: 8,
  fill: "none"
})), React.createElement("g", {
  transform: "translate(14 14)",
  fill: "none",
  stroke: "#091832",
  strokeWidth: 2
}, React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 2,
  stroke: "none"
}), React.createElement("rect", {
  x: 1,
  y: 1,
  width: 18,
  height: 18,
  rx: 1,
  fill: "none"
})));

var SvgToolFigureSquare = function SvgToolFigureSquare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgToolFigureSquare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tool Figure Square.7feb3d8b.svg";
export { ForwardRef as ReactComponent };